
IREP.ForumBand = (function () {
    var startingPoint;

    var init = function () {
        
        var forumDisplay = true;
        var forumTarget = $('#ForumHolder').offset().top;
        startingPoint = $(".ForumHeader");
        var $ForumRows = $(".ForumRow")
        var $ForumsToShow = 3;
        var $i = 0;
        for (var i = 0; i < $ForumsToShow; i++) {
            $ForumRows.eq(i).css("display", "block");
        }

        var tl = new TimelineLite();
        tl.from($(".ForumHeader"), 1, { autoAlpha: 0 });
        tl.staggerFrom($(".ForumRow"), .25, { opacity: 0, height: "0px", ease: Expo.easeIn, overwrite: 2 }, .35);

        var interval = setInterval(function () {
            if ($(window).scrollTop() + $(window).height() > forumTarget && forumTarget + $('#ForumHolder').height() > $(window).scrollTop() && forumDisplay) {
                forumDisplay = false;
                tl.play();
            }
        }, 250);


        window.setInterval(function () {

            // set all the displayed items to display none
            $ForumRows.each(function (index) {
                if ($(this).css("display") == "block") {
                    TweenMax.fromTo($(this), .25, { rotationX: 0, transformOrigin: "50% 100%" }, { rotationX: -90, ease: Linear.easeNone, transformOrigin: "50% 0%", overwrite: 2 });
                    TweenMax.to($(this), 0, { alpha: 0, delay: .5, onComplete: hideMe, onCompleteParams: [$(this)] });
                    // keep track of the last element that was displayed of the previous set
                    $i = index;
                }
            });
            $i++;
            if ($i == $ForumRows.length) {
                // if we are at the end, start over
                $i = 0;
            }

            // starting with that item, begining changing display to block
            for (var j = 0; j < $ForumsToShow; j++) {
                TweenMax.to($ForumRows.eq($i), 0, { alpha: 1, delay: .5, onComplete: showMe, onCompleteParams: [$ForumRows.eq($i)] });
                TweenMax.fromTo($ForumRows.eq($i),.5, { rotationX:-90, transformOrigin: "50% 100%" }, { rotationX: 0, ease: Linear.easeNone, delay: .5, overwrite: 2 })

                // if we get to the last item, start over on the next pass
                $i++;
                if ($i == $ForumRows.length) {
                    break;
                }
            }
            startingPoint = $(".ForumHeader");
        }, 5000);
    }

var hideMe = function ($me) {
        $me.css("display", "none");
    }

var showMe = function($me) {
        $me.css("display", "block");
        $me.insertAfter(startingPoint);
        startingPoint = $me;
    }

        
    return {
        init: init
    };
})();